




import { Vue, Component } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';
import videojs from 'video.js';
import 'videojs-resolution-switcher/lib/videojs-resolution-switcher';
import 'videojs-transcript-ac/dist/videojs-transcript.min';

@Component
export default class VirtualMediaComponent extends Vue {
  public mounted(): void {
    const videoCssClasses: string = 'video-js vjs-fluid vjs-default-skin vjs-big-play-centered';
    $('video').each((i, video) => this.initMedia(video, videoCssClasses, true));

    const audioCssClasses: string = 'video-js vjs-fluid vjs-default-skin';
    $('audio').each((i, audio) => {
      this.initMedia(audio, audioCssClasses, false);

      this.hideButtonsForAudio();
    });
  }

  private initMedia(mediaElement: any, cssClasses: string, fullscreen: boolean): void {
    const $media = $(mediaElement);
    $media.addClass(cssClasses);

    const player = videojs(mediaElement, {
      preload: 'none',
      // poster: require('@/assets/images/example-image.png'),
      controls: true,
      controlBar: {
        volumePanel: false,
        muteToggle: false,
        fullscreenToggle: fullscreen
      }
    });

    if (this.hasMultipleResolutions($media)) {
      player.videoJsResolutionSwitcher({
        default: this.calculateDefaultResolution($media),
        dynamicLabel: true
      });
    }

    player.ready(() => {
      if (player.textTracks().length > 0) {
        const transcriptElementId: string = uuidv4();
        $media.after(`<div id="${transcriptElementId}" class="video-transcript"></div>`);
        this.addTranscript(player, transcriptElementId);
      }

      this.addEventHandler($media.attr('id') as string);
    });
  }

  private addEventHandler(elementId: string) {
    $(`#${elementId}`).on('play', () => {
      $('video, audio').each((i, item) => {
        const currentElementId: string = $(item).attr('id') as string;
        if (currentElementId !== elementId) {
          (item as any).pause();
        }
      });
    });
  }

  private hasMultipleResolutions($video: any): boolean {
    let result: boolean = true;
    $('source', $video).each((i, source) => {
      const $source = $(source);
      const hasRequiredAttributes: boolean = $source.attr('res') !== undefined && $source.attr('label') !== undefined;
      if (!hasRequiredAttributes) {
        result = false;
      }
    });

    return result;
  }

  private calculateDefaultResolution($video: any): string {
    const screenResolution: number = window.screen.height * window.devicePixelRatio;
    let resolutionToUse: number = 0;
    $('source', $video).each((i, source) => {
      const res: string|undefined = $(source).attr('res');
      if (res) {
        const videoResolution: number = parseInt(res, 10);
        if (screenResolution >= videoResolution && resolutionToUse < videoResolution) {
          resolutionToUse = videoResolution;
        }
      }
    });

    return resolutionToUse.toString();
  }

  private addTranscript(player: any, transcriptElementId: string): void {
    const transcript = player.transcript({});
    const $transcriptContainer: any = $(`#${transcriptElementId}`);
    $transcriptContainer.append(transcript.el());
  }

  private hideButtonsForAudio() {
    const selector = '.audio .vjs-descriptions-button, .audio .vjs-captions-button';
    $(selector).remove();
  }
}
